import apiZelo from '../backAxiosVendaToken';

export const ListaStatusRemessa = async inscricao => {
    try {
        const response = await apiZelo.get(`/pagamentos/debito-automatico?inscricao=${inscricao}`);

        return response.data;
    } catch (error) {
        return error.message;
    }
};

export const ReenviaLink = async body => {
    try {
        const response = await apiZelo.post('/assinatura', body);

        return response.data;
    } catch (error) {
        return error.message;
    }
};
